module.exports = __webpack_public_path__ + "static/media/logo.329b1d49.png";